<template>
	<div>
		<a-form-model ref="addForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"  :model="theObj" :rules="rules">
			<a-form-model-item label="用户名"  prop="adminName">
				<a-input v-model="theObj.adminName"/>
			</a-form-model-item>
			<a-form-model-item label="登录名"  prop="loginName">
				<a-input v-model="theObj.loginName"/>
			</a-form-model-item>
			<a-form-model-item label="手机"  prop="adminMobile">
				<a-input v-model="theObj.adminMobile" />
			</a-form-model-item>
			<a-form-model-item label="固话" prop="adminTel">
				<a-input v-model="theObj.adminTel" />
			</a-form-model-item>
			<a-form-model-item label="邮箱"  prop="adminEmail">
				<a-input v-model="theObj.adminEmail"/>
			</a-form-model-item>
			<a-form-model-item label="地址"  prop="adminAddr">
				<a-input v-model="theObj.adminAddr"/>
			</a-form-model-item>
			<a-form-model-item label="权限"  prop="roleId">
				<a-select style="width:20rem;" v-model="theObj.roleId" placeholder="请选择权限"  show-search
						option-filter-prop="children" :filter-option="filterOption">
					<a-select-option v-for="(item,index) in theInfo.roleList"  :value="item.PID" :key="item.PID">
						{{item.RoleName}}
					</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="片区"  prop="departmentId">
				<a-select style="width:20rem;" v-model="theObj.departmentId" placeholder="请选择片区"  show-search
						option-filter-prop="children" :filter-option="filterOption">
					<a-select-option v-for="(item,index) in theInfo.departList"  :value="item.pId" :key="item.pId">
						{{item.departmentName}}
					</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="管理员类型"  prop="noWc">
				<a-select style="width:20rem;"  @change="typeChange" :default-value="theType">
					<a-select-option value="0">
						自来水公司
					</a-select-option>
					<a-select-option value="1">
						物业
					</a-select-option>
				</a-select>
			</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default{
		props:['theObj'],
		data(){
			return{
				rules:{
					adminName:[{required:true,message:'请输入用户名',trigger: 'blur'}],
					roleId:[{required:true,message:'请选择权限',trigger: 'change'}],
				},
				submitFlag:false,
				theInfo:{},
			}
		},
		methods:{
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			onClose:function(flag){
				this.$emit('cancelEdit');
				if(flag){
					this.$emit('refreshList');
				}
			},
			onSubmit:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					} else {
						return false;
					}
				});
				
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.USER_ADMIN_UPDATE_URL);
				this.Api.fetchPostWithForm(url,this.theObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('修改成功');
						this.onClose(true);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.submitFlag = false;
					console.log(error);
				});
			},
			getUserAdminAddInfo:function(){
				let url = this.Api.getLastUrl(this.Api.USER_ADMIN_ADD_INFO_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.theInfo = data.data.result;
				}).catch((error)=>{
					console.log(error);
				});
			},
			typeChange:function(value,options){
				this.theObj.noWc = value;
			},
		},
		created() {
			this.getUserAdminAddInfo();
			if(this.theObj.departmentId == 0 ){
				this.theObj.departmentId = null;
			}
		},
		computed:{
			theType:function(){
				if(this.theObj.noWc == 1){
					return '物业';
				}else{
					return '自来水公司';
				}
			}
		}
	}
</script>

<style>
</style>
